module.exports = new __parcel__URL__("7557-1.7d401f9d.png").toString();